import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet-async';
import 'react-toastify/dist/ReactToastify.css';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Sections
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Skills from './components/sections/Skills';
import Experience from './components/sections/Experience';
import Projects from './components/sections/Projects';
import Contact from './components/sections/Contact';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoading = () => {
      setLoading(false);
    };

    if (document.readyState === 'complete') {
      handleLoading();
    } else {
      window.addEventListener('load', handleLoading);
    }

    return () => {
      window.removeEventListener('load', handleLoading);
    };
  }, []);

  // Simple loader
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-bg-primary">
        <div className="relative">
          <div className="w-12 h-12 rounded-full border-2 border-accent-blue/20 border-t-accent-blue animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Cheovari Ionut | Developer & Lawyer</title>
        <meta name="description" content="Cheovari Ionut — Web Developer, Lawyer, and Founder of Destroyed Secure. Python, Django, React specialist based in Cluj-Napoca." />
        <meta name="keywords" content="Web Developer, Lawyer, Founder of Destroyed Secure, React, Django, Python, Legal Tech" />
      </Helmet>

      <div className="bg-bg-primary min-h-screen">
        <Navbar />

        <main>
          <Hero />
          <About />
          <Skills />
          <Experience />
          <Projects />
          <Contact />
        </main>

        <Footer />
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default App;
